<template>
  <div id="content">

    <label for="toggle-phones" class="icon-for-phones" v-show="showPhoneToggle">
      <icon>
        <icon :name="showAllPhones ? 'times' : 'phone'" scale="2" class="phone"></icon>
      </icon>
    </label>
    <input type="checkbox" id="toggle-phones" v-model="showAllPhones">
    <transition name="fade" mode="out-in">
      <div class="contact-info" v-show="showAllPhones">
        <table>
          <tbody>
            <tr v-for="(phone, key) in phones" v-bind:key="key">
              <td>
                <span class="destination">{{ phone.destination }}</span>
              </td>
              <td>
                <span class="phone">{{ phone.number }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </transition>
    <Maps></Maps>
  </div>
</template>

<script>
  import Maps from './common/Maps'
  import Icon from 'vue-awesome/components/Icon'
  import 'vue-awesome/icons/phone'
  import 'vue-awesome/icons/times'
  import 'vue-awesome/icons/square'
  import getMeta from '../common/js/get-meta'
  export default {
    components: {
      Maps,
      Icon
    },
    mixins: [getMeta],
    props: ['windowWidth'],
    data () {
      return {
        title: 'Контакты',
        content: 'Телефоны, адрес СТО Автодизель',
        showAllPhones: true,
        showPhoneToggle: true,
        phones: [
          {
            destination: 'Стол заказов',
            number: '+7 856 387 44 61'
          },
          {
            destination: 'Стол заказов MTC',
            number: '099 070 50 42'
          },
          {
            destination: 'Стол заказов Феникс',
            number: '+7 949 346 69 40'
          }
        ]
      }
    },
    watch: {
      windowWidth: function (val) {
        if (val > 639) {
          this.showAllPhones = true
          this.showPhoneToggle = false
        } else {
          this.showAllPhones = false
          this.showPhoneToggle = true
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '../common/css/vars'

  .fa-icon
    color $red
    width auto
    height 3em
    max-width 100%
    max-height 100%

  .icon-for-phones
    position absolute
    z-index 3
    right 10px
    top 80px
    padding 1px 5px
    border 1px solid $red
    max-width 60px

  #toggle-phones
    display none

  #content
    background-image url('/static/bg2.jpg')

  .contact-info
    padding 10px
    z-index 2
    position absolute
    top 40%
    right 0
    background-color rgba(0, 0, 0, 0.7)

    .destination
      color $red
      font-family 'Open Sans'
      font-size 15px
      font-weight 600
      line-height 13.82px
      text-transform uppercase

    .phone
      color #ffffff
      font-family 'Open Sans - Semibold'
      font-size 16px
      font-weight 600
      line-height 13.82px
      text-transform uppercase

    table
      width 100%
      text-align center
      border-spacing 0

      td
        width 50%

        &:nth-of-type(1)
          border-right 2px solid #545454
          padding 5px 4px
</style>



// WEBPACK FOOTER //
// Contacts.vue?1300951c